import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardHeader,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Divider,
  Chip,
  Button,
  Stack,
  Typography,
} from '@mui/material';
import { EventRepeat } from '@mui/icons-material';
import { recurringApi } from '../services/api';
import { formatCurrency, formatDate } from '../utils/helpers';
import { groupSamePayments } from '../utils/upcoming';

/**
 * Dashboard: recurring payments and income expected in the next two weeks
 * (bills have their own card). Hidden when nothing is due.
 */
const UpcomingWidget = ({ sx }) => {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => {
    recurringApi.getUpcoming(14)
      .then(response => setItems(groupSamePayments((response.data.items || []).filter(item => item.kind !== 'bill'))))
      .catch(() => setItems([]));
  }, []);

  if (!items || items.length === 0) return null;

  return (
    <Card sx={sx}>
      <CardHeader
        avatar={<EventRepeat color="primary" />}
        title="Recurring in the next two weeks"
        action={<Button size="small" onClick={() => navigate('/upcoming')}>See all</Button>}
      />
      <CardContent sx={{ pt: 0 }}>
        <List disablePadding>
          {items.slice(0, 6).map((item, index) => (
            <React.Fragment key={`${item.kind}-${item.id}`}>
              {index > 0 && <Divider component="li" />}
              <ListItem disableGutters>
                <ListItemText
                  primary={
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography variant="body2">{item.name}{item.count > 1 ? ` ×${item.count}` : ''}</Typography>
                      {item.overdue && <Chip size="small" color="error" label="Overdue" />}
                    </Stack>
                  }
                  secondary={`Due ${formatDate(item.dueDate)}`}
                />
                <Typography variant="body2" color={item.direction === 'credit' ? 'success.main' : 'text.primary'}>
                  {item.amount === null ? '—' : `${item.direction === 'credit' ? '+' : ''}${formatCurrency(item.amount)}`}
                </Typography>
              </ListItem>
            </React.Fragment>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default UpcomingWidget;
